import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Button, SpaceBetween } from "@cloudscape-design/components";

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "60vh",
        padding: "40px 20px",
      }}
    >
      <SpaceBetween size="l" direction="vertical" alignItems="center">
        <div
          style={{
            fontSize: "120px",
            fontWeight: 700,
            lineHeight: 1,
            color: "#d91515",
            letterSpacing: "-4px",
            userSelect: "none",
          }}
        >
          404
        </div>
        <Box textAlign="center" variant="h2">
          Page Not Found
        </Box>
        <Box textAlign="center" color="text-body-secondary" fontSize="body-m">
          The page you are looking for does not exist. Please check the URL or navigate back to a valid page.
        </Box>
        <Button variant="primary" onClick={() => navigate("/")}>
          Back to Home
        </Button>
      </SpaceBetween>
    </div>
  );
};

export default NotFound;
